export default __webpack_public_path__ + "static/media/navbar-summary-dark.015cfe8e.svg";